module.exports = [{
      plugin: require('/home/runner/work/site-eledio.com/site-eledio.com/node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"/home/runner/work/site-eledio.com/site-eledio.com/src/intl","languages":["en","cs","de"],"defaultLanguage":"en","redirect":true},
    },{
      plugin: require('/home/runner/work/site-eledio.com/site-eledio.com/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
